import { WaveColor } from './wavedata.type';

export class WaveConfigOptions {
  autoScroll: boolean;
  autoCenter: boolean;
  dragToSeek: boolean;
  fillParent: boolean;
  barGap: number;
  barRadius: number;
  barWidth: number;
  cursorColor: WaveColor;
  cursorWidth: number;
  height: number;
  normalize: boolean;
  progressColor: WaveColor;
  waveColor: WaveColor;
  barHeight?: number;
}
